import { useCallback } from 'react';
import isEmail from 'validator/lib/isEmail';
import api from 'api';
import { useDispatch, useReduxState } from 'hooks';
import { actions } from 'store';
import { FormGroup, Text } from 'components/common/form';
import { ModalButtonWithForm } from '.';

interface Props {
  apiData: any;
  apiUrl: string;
  buttonText: string;
  disabled?: boolean;
  id: string;
  isDropdown?: boolean;
  tooltip?: string;
  successMessage: string;
}

const SendToEmailButton = ({
  apiData,
  apiUrl,
  buttonText,
  disabled,
  tooltip,
  id,
  isDropdown,
  successMessage
}: Props) => {
  const { messages } = useReduxState();
  const { dispatch } = useDispatch();

  const submit = useCallback(
    async (values) => {
      await api.post(apiUrl, {
        ...apiData,
        emailAddress: values.emailAddress
      });
      dispatch(
        actions.addNotice({
          text: successMessage,
          type: 'success'
        })
      );
    },
    [apiData, apiUrl, successMessage]
  );

  const validateEmailAddress = useCallback(
    (value) => {
      const trimmedValue = value?.toString().trim();

      return !trimmedValue
        ? messages.commonFieldRequired
        : !isEmail(trimmedValue, { domain_specific_validation: true })
        ? messages.usersInvalidEmail
        : undefined;
    },
    [messages]
  );

  return (
    <ModalButtonWithForm
      buttonCategory="success"
      buttonIcon="envelope"
      buttonIsDropdown={isDropdown}
      buttonText={buttonText}
      buttonProps={{ disabled, tooltip }}
      modalActionText={messages.commonSend}
      modalTitle={buttonText}
      onSubmit={submit}
      stopPropagation={true}
    >
      {(formState) => (
        <>
          <FormGroup
            htmlFor={`completion-send-to-email-${id}`}
            label={messages.commonEmailAddress}
          >
            <Text
              field="emailAddress"
              id={`completion-send-to-email-${id}`}
              placeholder={messages.loginEmailPlaceholder}
              validate={validateEmailAddress}
              validateOnChange={true}
            />
          </FormGroup>
        </>
      )}
    </ModalButtonWithForm>
  );
};

export default SendToEmailButton;
